import { routeCreator } from '@adrias-online/steiner';
import _ from 'lodash';

import { generateRoutes } from '../../../helpers/portaleModuleHelper';
import routeRegister from 'helpers/routeRegister';
import { selectors } from '../reducers/portaliPagineOfferte';

const routes = generateRoutes('portaliPagineOfferte', selectors);
const list = _.values(routes.list).map(route => ({
    ...route,
    requiredRoles: ['admin', 'developer', 'employee', 'amministrazione'],
    getComponent() {
        return new Promise(resolve => {
            import(/* webpackChunkName: 'portaliPagineOfferte' */ `modules/portaliPagineOfferte/${route.componentPath}`)
                .then(response => resolve(response.default));
        });
    },
}));

const links = routeCreator.generateLinks(routes.patterns);

routeRegister.addPatterns('portaliPagineOfferte', routes.patterns);
routeRegister.addLinks('portaliPagineOfferte', links);

export default list;